import { ghqs_parseQueryId } from './utils';
const $ = jQuery;

class GutenberghubSortQuery {
	/**
	 * Constructor.
	 *
	 *
	 * @param {HTMLDivElement} container Sorting container.
	 */
	constructor( container, queryContainer, queryLoopBlockIndex ) {
		this.container = container;
		this.queryLoopInstance = queryContainer;
		this.queryLoopBlockIndex = queryLoopBlockIndex;
		/**
		 * Query Id.
		 */
		this.queryId = ghqs_parseQueryId( this.queryLoopInstance );

		/**
		 * Radio Container.
		 */
		this.radiosContainer = this?.container?.querySelector(
			'.gutenberghub-query-sort .gutenberghub-query-sort-radio'
		);

		/**
		 * Sorting menu buttons
		 */
		this.sortingButtons = this.container.querySelectorAll(
			'.gutenberghub-query-sort-menu a'
		);

		/**
		 * Sorting selectbox
		 */
		this.sortingSelectBox = this?.container?.querySelector(
			'.gutenberghub-query-sort select'
		);

		if ( this.sortingSelectBox ) {
			this.initializeSelectbox();
		} else if ( this.sortingButtons.length > 0 ) {
			this.initializeMenu();
		} else if ( this.radiosContainer ) {
			this.initializeRadio();
		}
	}

	/**
	 * Removes the taxonomy query.
	 *
	 * @param {string} taxonomy - Taxonomy name.
	 *
	 * @return {void}
	 */
	removeQuery( taxonomy ) {
		const url = new URL( location.href );
		url.searchParams.delete( taxonomy );
		location.assign( url.search );
	}
	/**
	 * Initializes the selectbox filter.
	 *
	 * @return {void}
	 */
	initializeSelectbox() {
		const url = new URL( location.href );
		if ( Number( url.searchParams.get( 'qid' ) ) === this.queryId ) {
			this.sortingSelectBox.value = this.activeSortFilter();
		}

		this.sortingSelectBox?.addEventListener( 'change', ( event ) => {
			if ( event.target.value !== '' ) {
				this.loadQuery( event.target?.value );
			} else {
				this.removeQuery( event.target?.name );
			}
		} );
	}

	activeSortFilter() {
		const url = new URL( location.href );
		return url.searchParams.get( 'qsort' ) ?? 'new-to-old';
	}

	/**
	 * Initializes the radio filter.
	 *
	 * @return {void}
	 */
	initializeRadio() {
		const radios = this.radiosContainer?.querySelectorAll(
			'input[type="radio"]'
		);
		const url = new URL( location.href );

		radios.forEach( ( radio ) => {
			if (
				radio.value === this.activeSortFilter() &&
				Number( url.searchParams.get( 'qid' ) ) === this.queryId
			) {
				radio.checked = true;
			} else {
				radio.checked = false;
			}
		} );

		radios?.forEach( ( radio ) => {
			radio.addEventListener( 'change', ( event ) => {
				const includedTerms = Array.from( radios )
					.filter( ( radio ) => {
						if ( radio.name === event.target.value ) {
							return event.target.checked;
						} else {
							return radio.checked;
						}
					} )
					.map( ( radio ) => radio.value );

				if ( includedTerms.length > 0 ) {
					this.loadQuery( event.target.value );
				}
			} );
		} );
	}
	/**
	 * Initializes the menu filter
	 *
	 * @return {void}
	 */

	initializeMenu() {
		const url = new URL( location.href );
		this.sortingButtons.forEach( ( button ) => {
			button.classList.remove( 'is-active-menu' );

			if (
				this.activeSortFilter() === button.dataset.slug &&
				Number( url.searchParams.get( 'qid' ) ) === this.queryId
			) {
				button.classList.add( 'is-active-menu' );
			}
		} );

		this.sortingButtons.forEach( ( button ) => {
			button.addEventListener( 'click', () => {
				const term = button.dataset.slug;

				this.sortingButtons.forEach( ( button ) => {
					button.classList.remove( 'is-active-menu' );
				} );

				button.classList.add( 'is-active-menu' );
				this.loadQuery( term );
			} );
		} );
	}
	/**
	 * Loads the taxonomy query.
	 *
	 * @param { string;} query
	 * @param {string[]|false} include Include just the given terms.
	 *
	 * @return {void}
	 */
	loadQuery( term, include = false ) {
		const url = new URL( location.href );
		url.searchParams.set( 'qsort', term );
		url.searchParams.set( 'qid', this.queryId.toString() );

		const postTemplate = $( this.queryLoopInstance ).find(
			'.wp-block-post-template'
		);
		const self = this;

		$.ajax( {
			url: url.href,
			success: function ( response ) {
				const responseDocument = $( $.parseHTML( response ) );
				const newPostWrapper = responseDocument.find(
					`.wp-block-query`
				)[ self.queryLoopBlockIndex ];

				const newPosts = $( newPostWrapper ).find(
					`.wp-block-post-template .wp-block-post`
				);

				postTemplate.html( newPosts );
			},
		} );
		window.history.pushState( {}, '', decodeURIComponent( url ) );
	}
}

window.addEventListener( 'load', () => {
	/**
	 * @type {NodeListOf<HTMLDivElement>} Loop Blocks.
	 */
	const ctbQueryLoopBlocks = document.querySelectorAll( '.wp-block-query' );

	ctbQueryLoopBlocks.forEach( ( queryLoopBlock, queryBlockIndex ) => {
		/**
		 * @type {NodeListOf<HTMLDivElement>}
		 */
		const sortContainers = queryLoopBlock.querySelectorAll(
			':scope .gutenberghub-query-sort'
		);

		sortContainers.forEach( ( sortContainer ) => {
			new GutenberghubSortQuery(
				sortContainer,
				queryLoopBlock,
				queryBlockIndex
			);
		} );
	} );
} );
